var map = {
	"./aws.webp": 3284,
	"./c-sharp.webp": 8109,
	"./css.webp": 4286,
	"./django.webp": 5864,
	"./firebase.webp": 1034,
	"./html.webp": 1726,
	"./java.webp": 5455,
	"./kotlin.webp": 5574,
	"./mongodb.webp": 5451,
	"./next.webp": 3986,
	"./node.webp": 4791,
	"./postgresql.webp": 229,
	"./python.webp": 6517,
	"./react.webp": 942,
	"./sql.webp": 6317,
	"./typescript.webp": 4360,
	"./vue.webp": 7273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 492;